<template>
    <div class="lender-dashboard">
      <div class="d-flex justify-content-center" style="">
        <div style="width: 85%">
          <div class="d-flex">
            <div class="flex-grow-1 mb-5" style="overflow: hidden">
              <b
                style="
                  font-size: 80px;
                  color: #404040;
                  display: block;
                  margin-top: -26px;
                "
                class="text-truncate"
                >{{ activeLender?.name }}</b
              >
  
              <div class="d-flex" style="margin-left: 8px; gap: 20px">
                <div style="font-size: 25px">
                  {{ schoolList.length }}
                  {{ schoolList.length > 1 ? "Schools" : "School" }}
                </div>
  
                <img
                  style="
                    width: 1px;
                    position: relative;
                    overflow: hidden;
                    max-width: 100%;
                    flex-shrink: 0;
                  "
                  src="/static/img/separator.svg"
                />
  
                <div style="font-size: 25px">
                  {{ activeLender?.lenderToStudentMaps.length }}
                  Students
                </div>
  
              </div>
              <div class="d-flex" style="margin-left: 8px; gap: 20px; width: 50%">
    
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    getGradeColor,
    getTrackingColor,
  } from "@/util/gradesAndTrackingColors";
  import LendersAPIService from "../../../../servicehandlers/LenderAPIService";

  import { getProcessedImageUrl } from "@/util/images";
  const lendersAPIService = new LendersAPIService();
  
  export default {
    components: {
    },
    data() {
      return {
        schoolList: [],
        activeLender: null,
      };
    },
    mounted() {
      this.getLenders();
    },

    methods: {
      getProcessedImageUrl,
      getTrackingColor,
      getGradeColor,
      getLenders() {
        const lenderId = this.$store.getUser.lenderId;
  
        lendersAPIService
          .getLendersById(lenderId, this.$router)
          .then((lender) => {
            this.activeLender = lender;
  
            lendersAPIService
              .getLenderWithTotalAmountLent(lenderId, this.$router)
              .then((totalLent) => {
                this.activeLender.totalLent = totalLent.reduce(
                  (acc, curr) => acc + curr,
                  0,
                );
              });
  
            lendersAPIService
              .getLenderSchoolsById(lenderId, this.$router)
              .then((schools) => {
                this.schoolList = this.$global.groupArrayByKeys(
                  schools.flightSchools,
                  ["id"],
                  true,
                );
              });
          });
      },
    },
  };
  </script>
  
  <style scoped>
  .lender-dashboard {
    font-family: Arial, sans-serif;
    color: #333;
  }
  
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .header h1 {
    margin: 0;
  }
  
  .logos {
    display: flex;
    justify-content: space-around;
    margin-bottom: 50px;
  }
  
  .logo-item {
    margin: 10px;
  }
  
  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .logo-container img {
    width: 300px;
    height: auto;
  }
  
  .students {
    display: flex;
    justify-content: space-around;
    margin-bottom: 40px;
  }
  
  .student-card {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    width: 400px;
    text-align: center;
    background-color: #f9f9f9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0 10px;
  }
  
  .student-card h3 {
    margin: 0 0 10px;
    font-size: 18px;
  }
  
  .program {
    font-size: 14px;
    color: #555;
  }
  
  .dates {
    font-size: 12px;
    color: #888;
    margin: 10px 0;
  }
  
  .days-behind {
    background-color: red;
    color: white;
    border-radius: 5px;
    padding: 2px 10px;
    font-weight: bold;
    font-size: 14px;
  }
  
  .student-info {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  
  .student-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 10px 0;
  }
  
  .grade {
    color: white;
    border-radius: 8px;
    width: 60px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
  }
  
  .progress-wrapper {
    position: relative;
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .progress {
    background-color: #babbbb;
    height: 10px;
    border-radius: 5px;
    position: relative;
    width: 80%;
    overflow: hidden;
  }
  
  .progress span {
    display: block;
    height: 100%;
    background-color: green;
    transition: width 0.3s ease;
  }
  
  .progress-value {
    font-size: 12px;
    font-weight: bold;
    margin-left: 10px;
    color: #333;
  }
  </style>
  
  <style lang="scss" scoped>
  .countiesTask {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 20px;
  
    th {
      background-color: #194099;
      color: #ffffff;
      text-align: center;
      font-weight: normal;
      font-size: 15px;
      padding: 10px;
    }
    th:first-child {
      border-top-left-radius: 10px;
    }
    th:last-child {
      border-top-right-radius: 10px;
    }
    td {
      text-align: center;
      border: 1px solid rgba(64, 64, 64, 0.5);
      border-style: none solid solid none;
    }
    tr {
      td {
        font-size: 15px;
      }
      td:first-child {
        padding-left: 10px;
        padding-right: 10px;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    tr:first-child td {
      border-top-style: solid;
    }
    tr td:first-child {
      border-left-style: solid;
    }
    tr:last-child td:first-child {
      border-bottom-left-radius: 10px;
    }
  
    tr:last-child td:last-child {
      border-bottom-right-radius: 10px;
    }
  
    th:nth-child(1),
    td:nth-child(1) {
      width: 15%; /* Adjust the width as needed */
    }
    th:nth-child(2),
    td:nth-child(2) {
      width: 15%; /* Adjust the width as needed */
    }
    th:nth-child(3),
    td:nth-child(3) {
      width: 15%; /* Adjust the width as needed */
    }
    th:nth-child(4),
    td:nth-child(4) {
      width: 15%; /* Adjust the width as needed */
    }
    th:nth-child(5),
    td:nth-child(5) {
      width: 15%; /* Adjust the width as needed */
    }
    th:nth-child(6),
    td:nth-child(6) {
      width: 15%; /* Adjust the width as needed */
    }
    th:nth-child(7),
    td:nth-child(7) {
      width: 10%; /* Adjust the width as needed */
    }
  }
  
  .expandable {
    .chevron {
      transform: rotate(180deg);
      transition: transform 0.3s ease;
    }
  
    &.expanded {
      .chevron {
        transform: rotate(0deg);
      }
    }
  }
  
  .accordionBody {
    max-height: 0;
    transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
    overflow: hidden;
  
    &.expanded {
      max-height: 1000px;
      transition: max-height 0.3s cubic-bezier(0.4, 0, 1, 1);
    }
  }
  
  .boxcontainer {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    overflow: hidden;
    padding: 10px;
    box-sizing: border-box;
    gap: 10px;
  }
  
  .tag {
    color: #ffffff;
    border-radius: 5px;
    padding: 2px 10px;
    font-size: 14px;
    align-self: center;
  
    &.red {
      background-color: red;
    }
  
    &.blue {
      background-color: #2c65ea;
    }
    &.gray {
      background-color: #b5b5b5;
    }
  }
  
  .rating-bar {
    width: 100%;
    height: 20px;
    background-color: #e2e6e5;
    border-radius: 10px;
    overflow: hidden;
  
    .rating {
      height: 100%;
      background-color: green;
      width: 50%;
      border-radius: 10px;
      transition: width 0.3s ease;
      text-align: center;
      color: white;
      font-size: 12px;
      line-height: 20px;
    }
  }
  
  .studentGrid {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  
    th {
      background-color: #3c97ff;
      color: #ffffff;
      text-align: center;
      font-weight: normal;
      font-size: 15px;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  
    th:first-child {
      border-top-left-radius: 10px;
    }
    th:last-child {
      border-top-right-radius: 10px;
    }
  
    td {
      text-align: center;
      border: 1px solid rgba(64, 64, 64, 0.5);
      border-style: none solid solid none;
    }
    tr {
      td {
        font-size: 15px;
      }
      td:first-child {
        padding-left: 10px;
        padding-right: 10px;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    tr:first-child td {
      border-top-style: solid;
    }
    tr td:first-child {
      border-left-style: solid;
    }
  
    td:nth-child(2) {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  
    td:nth-child(3) {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  .formLabel {
    margin-top: 10px;
    position: relative;
    font-size: 18px;
    font-family: Helvetica, Arial, sans-serif;
    color: #404040;
    text-align: left;
    display: inline-block;
  }
  </style>
  